import { render } from "./PurchaseRma.vue?vue&type=template&id=62153a02&scoped=true&ts=true&lang=pug"
import script from "./PurchaseRma.vue?vue&type=script&lang=ts"
export * from "./PurchaseRma.vue?vue&type=script&lang=ts"

import "./PurchaseRma.vue?vue&type=style&index=0&id=62153a02&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62153a02"]])

export default __exports__